























































import {Vue, Component, Prop} from 'vue-property-decorator'
import {InputSelect} from '@simpli/vue-input'
import {$} from '@/facade'
import {ContractCollection} from '@/model/collection/ContractCollection'
import {DappCollection} from '@/model/collection/DappCollection'

@Component({
  components: {
    InputSelect,
  },
  computed: {
    $() {
      return $
    },
  },
})
export default class FilterInvocation extends Vue {
  @Prop({type: Object, required: true}) contractCollection!: ContractCollection
  @Prop({type: Object, required: true}) dappCollection!: DappCollection
  @Prop({type: String, required: true}) groupSelected!: string

  get searchCollection(): ContractCollection | DappCollection {
    return this.groupSelected === 'dApps'
      ? this.dappCollection
      : this.contractCollection
  }

  get adapSearchFieldPlaceholder() {
    return `Search ${this.groupSelected}`
  }

  handleSelectGroup(value: string) {
    this.$emit('select-group', value)
  }
}
